// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ayQf8KyMkEmYpmxq1UiG{margin-left:20px;margin-right:20px}.uu5Vj2rIFN4f_pFuT6cr{background:var(--border-neutral-default);width:calc(100% - 40px);height:1px;margin:16px 20px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ayQf8KyMkEmYpmxq1UiG`,
	"separator": `uu5Vj2rIFN4f_pFuT6cr`
};
export default ___CSS_LOADER_EXPORT___;
